import React from "react";
import "./style.css";
import {Button, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown} from "reactstrap";
import {MdMoreVert} from "react-icons/md";
import {useNavigate} from "react-router";
import {LuPackagePlus} from "react-icons/lu";
import {toFarsiNumber} from "../../../../../shared/toFarsiNumber";
import {ConvertDateToCalendarString} from "../../../../../shared/convertDateToCalendarString";


const RequestApprovalNewVrsionItem = ({
                                          _id,
                                          isRequesting,
                                            createdAt,
                                          name,
                                          changes,
                                            version,
                                          developerName,
                                            file,
                                          onApprove,
                                          onReject,
                                      }) => {

    const navigate = useNavigate();
    console.log('isRequesting', isRequesting)

    return (
        <div className="request-approval-container">
            {/* Line 1 */}
            <div className="line">
                <div className="d-flex flex-row"  style={{gap: "10px"}}>
                    <div className="version-icon-background">
                        <LuPackagePlus size={36} color={"#38AF84"}/>
                    </div>
                    <span className="bot-name">{name}</span>
                </div>
                <UncontrolledDropdown>
                    <DropdownToggle
                        tag="a"
                        href="#more"
                        onClick={(ev) => ev.preventDefault()}
                        className="dropdown-toggle btn btn-icon btn-trigger p-1"
                    >
                        <MdMoreVert size={30} color={"#c7c7c7"}/>
                    </DropdownToggle>
                    <DropdownMenu end>
                        <ul className="link-list-opt no-bdr">
                            <li key={`kyc-item-edit-order-`}>
                                <DropdownItem
                                    disabled={!file}
                                >
                                    <a href={`${process.env.REACT_APP_FXPLT_LIARA_STORAGE}/${file}`}>دانلود</a>
                                </DropdownItem>
                            </li>
                        </ul>
                    </DropdownMenu>
                </UncontrolledDropdown>
            </div>

            {/* Line 2 */}
            <div className="line">
                <div className="d-flex flex-column w-100" style={{gap: "20px"}}>
                    {/* User Info */}

                    <div  className={'request-approval-developer-and-date'}>توسط. {developerName}. {ConvertDateToCalendarString(createdAt)}</div>
                    <div className={'request-approval-version-number'}>نسخه {toFarsiNumber(version)}</div>
                    <div>
                        <span>تغییرات نسخه</span>
                        <div>
                            <div dangerouslySetInnerHTML={{__html: changes}}/>
                        </div>
                    </div>
                    <div className={"d-flex flex-row button-container w-100"} style={{gap: '10px'}}>

                        <Button disabled={isRequesting} className="button reject"  type="submit" onClick={async () => {

                            onReject()
                        }}>
                            رد کردن نسخه
                        </Button>
                        <Button disabled={isRequesting} className="button approve"  type="submit" onClick={async () => {
                            onApprove()
                        }}>
                            تایید نسخه
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RequestApprovalNewVrsionItem;